import config from "../../../../config";

export const scorecard2013 = `Scorecard2013/`;
export const getRegistrationMetaViewModel = `${scorecard2013}GetRegistrationMetaViewModel`;
export const createScorecardExternalRedirect = `${config.publicUrl}#createscorecard/`;
export const createGroupModuleExternalRedirect = `${config.publicUrl}#creategroup/manage/`;
export const createConsolidatedScorecardExternalRedirect = `${config.publicUrl}#createconsolidations/manage/`;